import { ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

/**
 * Thin progress line with a plane travelling left to right while a search runs.
 *
 * The search is a single request with no real progress signal, so the bar eases
 * towards 90% while loading and completes the trip the moment results arrive.
 */
@Component({
    selector: 'app-flight-progress',
    templateUrl: './flight-progress.component.html',
    styleUrls: ['./flight-progress.component.scss'],
    standalone: false
})
export class FlightProgressComponent implements OnChanges, OnDestroy {
  @Input() loading = false;

  progress = 0;
  visible = false;

  private timer: any = null;
  private hideTimer: any = null;

  constructor(private readonly zone: NgZone, private readonly cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['loading']) {
      return;
    }
    if (this.loading) {
      this.start();
    } else if (this.visible) {
      this.finish();
    }
  }

  ngOnDestroy(): void {
    this.clearTimers();
  }

  private start(): void {
    this.clearTimers();
    this.progress = 4;
    this.visible = true;
    // Tick outside Angular so the page is not change-detected five times a second.
    this.zone.runOutsideAngular(() => {
      this.timer = setInterval(() => {
        this.progress += (90 - this.progress) * 0.045;
        this.cdr.detectChanges();
      }, 200);
    });
  }

  private finish(): void {
    this.clearTimers();
    this.progress = 100;
    this.hideTimer = setTimeout(() => {
      this.visible = false;
      this.progress = 0;
      this.cdr.detectChanges();
    }, 650);
  }

  private clearTimers(): void {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }
}
